// app.states.js

"use strict";



const appDesktop = {
    name: "desktop",
    url: "/",
    component: "desktop",
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
      return import(/* webpackChunkName: "desktop.module" */ "./components/desktop/desktop.module")
        .then(mod => $ocLazyLoad.load(mod.DESKTOP_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    }
  };
  
  export { appDesktop };


// WEBPACK FOOTER //
// ./src/app.states.js